import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { recordLengthFormatter } from '../../../utils/recordLengthFormatter';
import { highchartsLabelFormatterFromMs } from '../../../utils/dateFormatter';
import Loading from '../Loading';

export function AllProcessedDataValues({ values, isDetailed, timeViewMode, recordStartTime, isLoading }) {
  const { t } = useTranslation();

  const formatTime = (timeInSeconds) => {
    // Return empty string if timeInSeconds is null, undefined, or NaN
    if (timeInSeconds == null || isNaN(timeInSeconds)) {
      return '';
    }
    
    if (timeViewMode === 1 && recordStartTime) {
      // Convert to actual time by adding record start time
      const startTimeMs = new Date(recordStartTime).getTime();
      // Check if recordStartTime is valid
      if (isNaN(startTimeMs)) {
        return '';
      }
      const actualTimeMs = startTimeMs + (timeInSeconds * 1000);
      return highchartsLabelFormatterFromMs(actualTimeMs);
    }
    return recordLengthFormatter(timeInSeconds, true);
  };

  // Check if data is not ready (no values or all key values are empty)
  const hasData = values && (values.averageHR || values.totalBeats || values.stressIndex);

  if (isLoading) {
    return (
      <Row>
        <Col className="px-3">
          <Loading />
        </Col>
      </Row>
    );
  }

  if (!hasData) {
    return (
      <Row>
        <Col className="px-3 text-muted">
          <em>{t('recordView.processedData.values.notEnoughData')}</em>
        </Col>
      </Row>
    );
  }

  return (
    <>
      <Row>
        <Col className="px-3">{t('recordView.processedData.values.averageHR')}: {values?.averageHR || ''}</Col>
        <Col className="px-3">{t('recordView.processedData.values.totalBeats')}: {values?.totalBeats || ''}</Col>
        <Col className="px-3">{t('recordView.processedData.values.si')}: {values?.stressIndex || ''}</Col>
      </Row>
      {isDetailed &&
        <Row>
          <Col className="px-3">{t('recordView.processedData.values.timeRange')}: {formatTime(values?.startSecond)} - {formatTime(values?.endSecond)}</Col>
          <Col className="px-3"></Col>
          <Col className="px-3"></Col>
        </Row>
      }
    </>
  )
}